<router-outlet></router-outlet>
<rxap-status-indicator class="fixed bottom-0 right-0 z-10"></rxap-status-indicator>
